import { FC } from 'react';
import { Span } from 'atoms/Typography';
import { TickIcon } from 'molecules/TickIcon';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './DeliveryStatus.module.css';

export enum DeliveryStatusType {
  AVAILABLE = 'green',
  PARTIALY_AVAILABLE = 'yellow',
  NOT_AVAILABLE = 'red',
}

export const DeliveryStatus: FC<{
  status: DeliveryStatusType;
  hovered?: boolean;
}> = ({ status, hovered }) => {
  const t = useTranslations();

  const deliveryText =
    status === DeliveryStatusType.NOT_AVAILABLE
      ? t('product.pdp.soldOutLabel')
      : t('product.tile.delivery');

  return (
    <div className={styles.root}>
      {!hovered && <Span className={styles.text}>{deliveryText}</Span>}
      <TickIcon color={status} />
    </div>
  );
};
